import CryptoJS from 'crypto-js'
import request from '@/utils/request'

const KEY = 'PdokelTjwi873u82l'

const getUserWallet = () => {
  return request({
    url: '/api/wallet',
    method: 'get'
  })
}

const refreshAllSlot = () => {
  return request({
    url: '/api/wallet/refresh/slot',
    method: 'get'
  })
}

const activateSlot = slotCode => {
  return request({
    url: `/api/wallet/activate/${slotCode}`,
    method: 'get'
  })
}

const accountSlot = slotCode => {
  return request({
    url: `/api/wallet/account/${slotCode}`,
    method: 'get'
  })
}

const resetPasswordSlot = slotCode => {
  return request({
    url: `/api/wallet/resetpassword/${slotCode}`,
    method: 'get'
  })
}

const add = amount => {
  return request({
    url: '/api/wallet/add',
    method: 'post',
    data: {
      amount: amount
    }
  })
}

const transfer = (from, to, amount) => {
  return request({
    url: '/api/wallet/transfer',
    method: 'post',
    data: {
      from: from,
      to: to,
      amount: amount
    }
  })
}

const transferAllToGame = to => {
  return request({
    url: '/api/wallet/transferAll',
    method: 'post',
    data: {
      to: to
    }
  })
}

const withdraw = amount => {
  return request({
    url: '/api/wallet/withdraw',
    method: 'post',
    data: {
      amount: amount
    }
  })
}

const withdrawAll = amount => {
  return request({
    url: '/api/wallet/withdrawAll',
    method: 'post',
    data: {
      amount: amount
    }
  })
}

const slip = formData => {
  return request({
    url: '/api/wallet/slip',
    method: 'post',
    timeout: 300000, // 5 mins
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    data: formData
  })
}

const trueLink = link => {
  const encrypt = CryptoJS.AES.encrypt(link, KEY)
  return request({
    url: '/api/wallet/truelink',
    method: 'post',
    data: {
      link: encrypt.toString()
    }
  })
}

export default {
  getUserWallet,
  refreshAllSlot,
  activateSlot,
  accountSlot,
  resetPasswordSlot,
  add,
  transfer,
  transferAllToGame,
  withdraw,
  withdrawAll,
  slip,
  trueLink
}
